<div class="address-content-wrapper">
  @if (!showAdditionalFields()) {
    <form
      class="needs-validation"
      id="address-form"
      [formGroup]="addressFormGroup"
    >
      <div class="main-card">
        <div class="row">
          <div class="col-md-12">
            <div class="map-wrapper">
              <ayen-map
                [apiLoaded]="apiLoaded"
                #ayenMap
                [lat]="latitude"
                [lang]="longitude"
                (mapValues)="mapValues($event)"
              ></ayen-map>
              @if (loadingAddress) {
                <div class="map-spinner-overlay">
                  <app-spinner></app-spinner>
                </div>
              }
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label"
                >المنطقة <span class="red">*</span></label
              >
              <ng-select
                bindLabel="name"
                class="single-select"
                placeholder="المنطقة"
                appendTo="body"
                formControlName="address_area"
                (change)="regionChanged()"
                [searchable]="true"
                [clearable]="true"
              >
                @for (region of regions; track region.pk) {
                  <ng-option [value]="region.pk">{{ region.name }}</ng-option>
                }
              </ng-select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label"
                >المدينة <span class="red">*</span></label
              >
              <ng-select
                [items]="cities"
                bindLabel="city_name"
                bindValue="pk"
                class="single-select"
                placeholder="المدينة"
                appendTo="body"
                formControlName="address_city"
                (change)="checkServiceCoverage()"
                [searchable]="true"
                [clearable]="true"
              >
              </ng-select>
            </div>
          </div>
          @if (!isCoveredLocation) {
            <div class="col-12">
              <div class="warning-wrapper">
                <img src="assets/images/svg/warning-icon.svg" alt="" />
                <p>
                  الموقع المختار خارج نطاق تغطية الخدمة حاليًا. سيقوم أحد
                  ممثلينا بالتواصل معك قريبًا.
                </p>
              </div>
            </div>
          }
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">الحي <span class="red">*</span></label>
              <ng-select
                bindLabel="district_name"
                class="single-select"
                placeholder="اختر الحي"
                appendTo="body"
                formControlName="district"
                [searchable]="true"
                [clearable]="true"
              >
                @for (district of districts; track district.pk) {
                  <ng-option [value]="district.pk">{{
                    district.district_name
                  }}</ng-option>
                }
              </ng-select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">رقم المبنى</label>
              <input
                type="text"
                formControlName="address_building_code"
                class="form-control"
                placeholder="ادخل رقم المبنى"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">كود العنوان الوطني</label>
              <input
                (input)="onShortAddressInput()"
                type="text"
                class="form-control"
                formControlName="short_address"
                maxlength="8"
                placeholder="ادخل كود العنوان الوطني"
              />
              @if (addressFormGroup.get("short_address")?.errors?.["pattern"]) {
                <span class="field-error"
                  >يجب إدخال 8 خانات (حروف وأرقام فقط) - مثال: RRRD2929</span
                >
              }
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">معلم بارز</label>
              <input
                type="text"
                formControlName="landmarks"
                class="form-control"
                placeholder="معلم بارز"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">اسم الشارع</label>
              <input
                type="text"
                formControlName="address_street"
                class="form-control"
                placeholder="ادخل اسم الشارع"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">رقم الوحدة</label>
              <input
                type="text"
                formControlName="address_unit_code"
                class="form-control"
                placeholder="ادخل رقم الوحدة"
              />
            </div>
          </div>
          @if (showAlertMsg) {
            <div class="alert-box">
              <img
                alt=""
                src="assets/images/svg/error-icon.svg"
                class="close-alert"
                (click)="hideErrorMsg()"
              />
              <p class="alert-msg">{{ alertMessage }}</p>
            </div>
          }
        </div>
      </div>
    </form>
  }
  <form
    class="needs-validation"
    id="inspect-form"
    [formGroup]="inspectionDetailsFormGroup"
  >
    <div class="main-card">
      <div class="row">
        @if (showAdditionalFields()) {
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label"
                >هدف العميل من الطلب <span class="red">*</span></label
              >
              <ng-select
                bindLabel="name"
                class="single-select"
                placeholder="هدف العميل من الطلب"
                appendTo="body"
                formControlName="client_goal"
                [searchable]="true"
                [clearable]="true"
              >
                @for (item of clientGoals; track item) {
                  <ng-option [value]="item.id">
                    {{ item.name }}
                  </ng-option>
                }
              </ng-select>
            </div>
          </div>
        }
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label"> {{ dateLabel }} <span class="red">*</span></label
            >
            <mat-form-field (click)="picker.open()" appearance="outline">
              <input
                matInput
                [min]="minDate"
                [placeholder]="datePlaceholder"
                formControlName="orderDate"
                [matDatepicker]="picker"
                disabled
              />
              <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon class="calender-icon">
                  <img src="assets/images/svg/calendar-admin-icon.svg" alt="" />
                </mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker [disabled]="disableDate"></mat-datepicker>
            </mat-form-field>
            <div class="checkBox-wrapper">
              <label class="checkbox-container">
                <input
                  type="checkbox"
                  formControlName="is_inspection_later"
                  (click)="toggleDisableDate($event)"
                />
                <span class="checkmark"> </span>
              </label>
              <span class="checkbox-label">
                موعد مفتوح
                <small>(تحديد الموعد لاحقا)</small>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">الفترة <span class="red">*</span></label>
            <app-select
              [optionItems]="inspectionPeriods"
              [placeholder]="'يرجى تحديد الفتره الفحص'"
              [initValues]="selectedPeriods"
              [disableSelect]="disableSelect"
              (selectedOptions)="setOrderPeriods($event)"
            ></app-select>
          </div>
        </div>
        @if (orderLoaded && order.order_type === orderType.Visit) {
          @if (
            order.building_type != buildingType.Land &&
            order.building_type != buildingType.Other
          ) {
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">حالة العقار</label>
                <ng-select
                  bindLabel="name"
                  class="single-select"
                  placeholder="يرجى اختيار حالة العقار"
                  appendTo="body"
                  formControlName="building_status"
                  [searchable]="true"
                  [clearable]="true"
                >
                  @for (type of buildingStatus; track type) {
                    <ng-option [value]="type.id">{{ type.name }}</ng-option>
                  }
                </ng-select>
              </div>
            </div>
          }
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">تخصص مزود الخدمة</label>
              <ng-select
                bindLabel="name"
                class="single-select"
                placeholder="يرجى تحديد تخصص مزود الخدمة"
                appendTo="body"
                formControlName="inspector_academic_major"
                [searchable]="true"
                [clearable]="true"
              >
                @for (item of acadamicMajor; track item) {
                  <ng-option [value]="item.id">{{ item.name }}</ng-option>
                }
              </ng-select>
            </div>
          </div>
        }
        <div class="col-md-12">
          <div class="notes-section form-group">
            <label class="form-label">ملاحظات إضافية</label>
            <textarea
              class="form-control"
              name="notes"
              formControlName="notes"
              maxlength="500"
            ></textarea>
          </div>
        </div>
        @if (inspectionAlertMsg) {
          <div class="alert-box">
            <img
              src="assets/images/svg/error-icon.svg"
              class="close-alert"
              alt=""
              (click)="hideErrorMsg()"
            />
            <p class="alert-msg">{{ inspectionAlertMessage }}</p>
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 confirm-next-step double-action">
        <button class="btn btn-grey" type="button" (click)="prevStep()">
          السابق
        </button>
        <button
          class="btn btn-green"
          type="button"
          (click)="save()"
          [disabled]="uploading"
        >
          التالي
        </button>
      </div>
    </div>
  </form>
</div>
